import { Icon, Modal, Typography, Box } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import React, { useState } from 'react'

const DeleteTalentModal = ({
  variant = 'underlined',
  selectedIds,
  handleRemove,
  multipleDelete = false,
  handleDrawer = () => {},
}) => {
  const [open, setOpen] = useState(false)

  const count = selectedIds.length
  const isDisabled = count === 0

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }
  const handleConfirmDelete = () => {
    handleRemove(selectedIds)
    handleToggle()
    handleDrawer()
  }

  return (
    <React.Fragment>
      {variant === 'underlined' ? (
        <Typography
          onClick={isDisabled ? () => {} : handleToggle}
          sx={{
            display: 'flex',
            color: isDisabled ? 'light-error.main' : 'error.main',
            cursor: isDisabled ? '' : 'pointer',
            textDecoration: 'underline',
            alignItems: 'center',
            gap: '2px',
          }}
        >
          <Icon sx={{ fontSize: '20px' }}>delete</Icon>
          Delete selected{!isDisabled && ` (${count})`}
        </Typography>
      ) : variant === 'outlined' ? (
        <AdxButton
          variant={'outlined'}
          onClick={handleToggle}
          color="error"
          sx={{ width: 1 / 2, '&:hover': { backgroundColor: 'light-error.main' } }}
        >
          Delete
        </AdxButton>
      ) : variant === 'icon' ? (
        <Icon
          onClick={handleToggle}
          sx={{ color: 'error.main', fontSize: '20px', cursor: 'pointer', marginRight: '10px' }}
        >
          delete
        </Icon>
      ) : null}
      <Modal
        open={open}
        onClose={handleToggle}
        sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Box
          sx={{
            backgroundColor: 'white.main',
            borderRadius: '6.5px',
            padding: '32px',
            maxWidth: '600px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Icon sx={{ color: 'warning.main', fontSize: '60px', marginBottom: '20px' }}>error</Icon>
          <Typography variant="h4" sx={{ textAlign: 'center', marginBottom: '6px' }}>
            {multipleDelete
              ? 'Do you confirm to delete all selected talents?'
              : 'Do you confirm to delete this talent?'}
          </Typography>
          <Typography
            sx={{ color: 'light-gray-text.main', marginBottom: '40px', textAlign: 'center' }}
          >
            {multipleDelete
              ? 'Deleting selected talents will permanently remove their information from your external talents list.'
              : 'Deleting this talent will permanently remove information from your external talents list.'}
          </Typography>
          <AdxButton
            variant={'contained'}
            onClick={handleConfirmDelete}
            fullWidth
            color="error"
            sx={{ marginBottom: '8px', '&:hover': { backgroundColor: '' } }}
          >
            Delete{!isDisabled && multipleDelete && ` (${count})`}
          </AdxButton>
          <AdxButton variant={'ghost'} onClick={handleToggle} fullWidth>
            Cancel
          </AdxButton>
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default DeleteTalentModal
